import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router';
import i18n from '../utils/locale';
import appStore from '../store/store';
import routes from './routes';
import DesignerApp from './components/DesignerApp';
import authMiddleware from '../utils/auth';
import axiosClient from '../utils/axios';
import 'vue-awesome/icons';
import Icon from 'vue-awesome/components/Icon';
import dataLoadMiddleware from '../utils/dataLoader';
import VTooltip from 'v-tooltip';
import VueObserveVisibility from 'vue-observe-visibility';
import VueMoment from 'vue-moment';
import Notifications from 'vue-notification';
import '../utils/general'; // Shared import
import ModalMixin from '../mixins/ModalMixin';
import {formatNumber} from '../utils/formatNumber';
import moment from "moment";
import SongLibrary from './components/SongLibrary.vue';
import { minutesToTimeInput } from '../utils/minutesToTimeInput';
import tinymce from 'tinymce/tinymce';

window.tinymce = tinymce;

Vue.use(VTooltip);
Vue.use(VueRouter);
Vue.use(Vuex);
Vue.use(VueMoment, {
    moment
});
Vue.use(Notifications);
Vue.use(VueObserveVisibility);
Vue.component('icon', Icon);
Vue.component('song-library', SongLibrary);

export const store = new Vuex.Store(appStore);

const router = new VueRouter({
    routes,
    base: window.DESIGNER_PATH,
    mode: 'history'
});

Vue.prototype.$http = new axiosClient(store, router);

router.beforeEach((to, from, next) => authMiddleware(store, to, from, next));
router.beforeEach((to, from, next) => dataLoadMiddleware(store, to, from, next, [
    'locations',
    'states',
    'companySettings'
], 'designer'));

const app = new Vue({
    router,
    store,
    i18n,

    components: {
        DesignerApp,
        Icon
    },

    mixins: [
        ModalMixin,
    ],

    provide(){
        return {
            http: Vue.prototype.$http,
            store: store,
        }
    },

    data() {
        return {
            version: COMPILE_VERSION,
            appVersion: APP_VERSION,
        };
    },

    methods: {
        minutesToTimeInput: minutesToTimeInput,

        formatNumber: formatNumber
    }
}).$mount('#app');

export default app;


